import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import { handleOpenMenuMobile, menuMobileSelector } from '../../entities/ComponentsSlice';
import AnimateLines from '../../features/animate-lines/AnimateLines';
import HeaderButtons from '../../features/header-buttons/HeaderButtons';
import HeaderLogo from '../../features/header-logo/HeaderLogo';
import ModalMenuRoutes from '../../shared/modal-menu-routes/ModalMenuRoutes';
import Wrapper from '../../shared/wrapper/Wrapper';
import style from './MenuMobile.module.scss';

function MenuMobile() {
  const dispatch = useDispatch();
  const contacts = useSelector(state => state.projectinfo.contacts);
  const openMenuMobile = useSelector(menuMobileSelector);

  const [toggle, setToggle] = useState(true);

  const animatedStyle = useSpring({
    config: {
      duration: 500,
    },
    opacity: toggle ? 0 : 1,
    delay: 0,
  });

  const animatedStyleHr2 = useSpring({
    config: {
      duration: 500,
    },

    opacity: toggle ? 1 : 0,
    delay: 0,
  });

  const windowWidth = window.innerWidth;

  const xTranslationHr1 = toggle ? '0px' : `${(6 / 414) * windowWidth}px`;
  const yTranslationHr1 = toggle ? '0px' : `${(3 / 414) * windowWidth}px`;
  const rotationHr1 = toggle ? 0 : -45;

  const xTranslationHr3 = toggle ? '0px' : `${(6 / 414) * windowWidth}px`;
  const yTranslationHr3 = toggle ? '0px' : `${(-15 / 414) * windowWidth}px`;
  const rotationHr3 = toggle ? 0 : 45;

  const animatedStyleHr1 = useSpring({
    config: {
      duration: 500,
    },
    transform: `translateX(${xTranslationHr1}) translateY(${yTranslationHr1}) rotate(${rotationHr1}deg)`,
    delay: 0,
  });

  const animatedStyleHr3 = useSpring({
    config: {
      duration: 500,
    },
    transform: `translateX(${xTranslationHr3}) translateY(${yTranslationHr3}) rotate(${rotationHr3}deg)`,
    delay: 0,
  });

  useEffect(() => {
    if (openMenuMobile) {
      setToggle(true);
      setTimeout(() => {
        setToggle(false);
      }, 400);
    }
  }, [openMenuMobile]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const svgRef = useRef(null);

  const [toggle2, setToggle2] = useState(false);

  useLayoutEffect(() => {
    if (svgRef) {
      setTimeout(() => {
        setToggle2(() => true);
      }, 800);
    }
  }, [svgRef]);

  const handleScrollTop = () => {
    dispatch(handleOpenMenuMobile(false));
  };

  return (
    <>
      <animated.div className={style.menuMobileContainer} style={{ ...animatedStyle }} ref={svgRef}>
        <div className={style.menuMobileSvg}>
          <AnimateLines id='vector_5_mob' className={style.svgClass} toggle={toggle2} />
        </div>
        <div className={style.menuMobileBox}>
          <div className={style.menuMobileLogo}>
            <HeaderLogo color='black' handleScrollTop={handleScrollTop} />
          </div>

          <div
            className={style.menuMobileBurgerMenu}
            onClick={() => {
              dispatch(handleOpenMenuMobile(false));
            }}
            role='button'
            tabIndex='0'
          >
            <animated.svg
              style={animatedStyleHr1}
              className={style.svgClassHr_1}
              viewBox='0 0 25 2'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect y='0.631348' width='25' height='1.31579' rx='0.657895' fill='black' />
            </animated.svg>
            <animated.svg
              style={animatedStyleHr2}
              className={style.svgClassHr_1}
              viewBox='0 0 25 2'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect y='0.631348' width='25' height='1.31579' rx='0.657895' fill='black' />
            </animated.svg>
            <animated.svg
              style={animatedStyleHr3}
              className={style.svgClassHr_1}
              viewBox='0 0 25 2'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect y='0.631348' width='25' height='1.31579' rx='0.657895' fill='black' />
            </animated.svg>
          </div>
        </div>
        <Wrapper>
          <div className={style.menuMobile}>
            <HeaderButtons toggleWhite={true} headerColorScheme='' />
            <ModalMenuRoutes />
            <div>
              <div className={style.menuMobile__links}>
                <a className={style.menuMobile__link} href={'mailto:' + contacts.mail}>
                  {contacts.mail}
                </a>
                <a className={style.menuMobile__link} href={'tel:' + contacts.phone}>
                  {contacts.phone}
                </a>
              </div>
            </div>
          </div>
        </Wrapper>
      </animated.div>
    </>
  );
}

export default MenuMobile;
